<div class="participant-modal">
    <div class="participant-header">
        <div class="header">
            <div class="info">
                <div class="title-number">
                    <div class="title">
                        Participants au cours
                    </div>
                    <div class="number" *ngIf="participantNumber>0">
                       {{participantNumber}}
                    </div>

                </div>
                <div class="description">
                    Collaborateurs inscrits à ce cours
                </div>

            </div>

        </div>
        <div class="upload">
            <img (click)="exportParticipants()" class="upload" src="assets/icons/upload.svg" alt="upload">
        </div>
        <div class="close">
            <img (click)="onCancelClick()" class="close" src="assets/icons/close X.svg" alt="close">
        </div>
    </div>

    <div class="participant-content" *ngIf="!loadingParticipant; else loading">
        <div class="participant-wrapper" *ngFor="let participant of participantList">
            <div class="participant-info-wrapper">
                <div class="image-wrapper">
                    <app-collab-profile-image 
                        [id]="participant.id" 
                        [firstName]="participant.firstname" 
                        [lastName]="participant.lastname" 
                        style="font-size: 11px;">
                    </app-collab-profile-image>
                </div>
                <div class="participant-info">
                    <div class="name">{{ participant.firstname }} {{ participant.lastname }}</div>
                    <div class="department">{{ participant.assignment }}</div>
                </div>
            </div>
        </div>
    </div>
    
</div>

<ng-template #loading>
    <div class="spinner-wrapper">
      <mat-spinner [diameter]="48"> </mat-spinner> 
    </div>
  </ng-template>